/**
* 系统管理 菜单管理
*/
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>基本设置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 主体内容 -->
        <el-row>
            <!-- title -->
            <div class="modt-box">小程序参数设置</div>
            <el-col :span="18">
                <el-form ref="form" :model="form" label-width="180px" :rules="rules">
                    <el-form-item label="商家最多可添加成员数" prop="member_number">
                        <el-input size="small" v-model="form.member_number"></el-input>
                    </el-form-item>
                    <el-form-item label="网站名称" prop="webname">
                        <el-input size="small" v-model="form.webname"></el-input>
                    </el-form-item>
                    <el-form-item label="锦胜雾森售后电话" prop="unifyTel">
                        <el-input size="small" v-model="form.unifyTel"></el-input>
                    </el-form-item>
                    <el-form-item label="凌阳售后电话" prop="lygkTel">
                        <el-input size="small" v-model="form.lygkTel"></el-input>
                    </el-form-item>
                    <el-form-item label="维保提醒时间" prop="repair_time">
                        <el-input size="small" v-model="form.repair_time"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="saveSetting('form')">保存</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {basicSetting} from '../../api/userMG'

    export default {
        data() {
            return {
                showdelete: false,
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                form: {
                    member_number: null,
                    webname: null,
                    unifyTel: null,
                    lygkTel: null,
                    repair_time: null
                },
                // rules表单验证
                rules: {
                    member_number: [
                        {required: true, message: '请填写商家最多可添加成员数', trigger: 'blur'}
                    ],
                    webname: [
                        {required: true, message: '请输入网站名称', trigger: 'blur'}
                    ],
                    unifyTel: [
                        {required: true, message: '请输入锦胜雾森售后电话', trigger: 'blur'}
                    ],
                    lygkTel: [{required: true, message: '请输入凌阳售后电话', trigger: 'blur'}],
                    repair_time: [
                        {required: true, message: '请输入维保提醒时间', trigger: 'blur'}
                    ]
                },
                fmenu: []
            }
        },
        /**
         * 创建完毕
         */

        created() {
            this.getdata()
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            // 获取数据
            getdata() {
                basicSetting()
                    .then(res => {
                        res.result.forEach(item => {
                            if (item.code == 'member_number') {
                                this.form.member_number = item.value
                            } else if (item.code == 'webname') {
                                this.form.webname = item.value
                            } else if (item.code == 'unifyTel') {
                                this.form.unifyTel = item.value
                            } else if (item.code == 'lygkTel') {
                                this.form.lygkTel = item.value
                            } else if (item.code == 'repair_time') {
                                this.form.repair_time = item.value
                            }
                        })
                    })
                    .catch(err => {
                        this.loading = false
                    })
            },
            // 添加
            saveSetting() {
                basicSetting(this.form).then(res => {
                    if (res.code == 200) {
                        this.$message.success('参数保存成功！')
                    } else {
                        this.$message.error('参数保存失败，请稍后再试！')
                    }
                })
            },
        }
    }
</script>

<style>
    .user-search {
        margin-top: 20px !important;
    }

    .user-search td {
        margin-top: 20px !important;
    }

    .userRole {
        width: 100%;
    }

    .el-table__expanded-cell {
        padding: 0px !important;
        margin: 0px !important;
    }

    .modt-box {
        width: 100%;
        height: 60px;
        line-height: 60px;
        background-color: #f0f2f5;
        text-align: center;
        color: #334157;
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 24px;
    }

    .mod-btnbox {
        margin-bottom: 20px;
    }

    .treeclass {
        border: 1px solid #f3f3f3;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .selectw {
        width: 100%;
    }
</style>
 
 


// WEBPACK FOOTER //
// src/views/basicSetting/index.vue